import { render, staticRenderFns } from "./ArticleStyleProductView.vue?vue&type=template&id=03d37b11&xmlns%3Aheight=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Awidth=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Afloat=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Aobject-fit=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./ArticleStyleProductView.vue?vue&type=script&lang=js&"
export * from "./ArticleStyleProductView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleStyleProductView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports